// FutureLab
import { feedbackQuestionSlice } from '../store/slices/feedbackSlice';

export const programQuestion = feedbackQuestionSlice.reducer;
